import _isObject from "lodash/isObject";
import _assign from "lodash/assign";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import PropTypes from "prop-types";
import Helpers from "../victory-util/helpers";

import CommonProps from "./common-props";
import Path from "./path";
import * as d3Shape from "d3-shape";

var Bar = function (_React$Component) {
  _inherits(Bar, _React$Component);

  function Bar() {
    _classCallCheck(this, Bar);

    return _possibleConstructorReturn(this, (Bar.__proto__ || Object.getPrototypeOf(Bar)).apply(this, arguments));
  }

  _createClass(Bar, [{
    key: "getPosition",
    value: function getPosition(props, width) {
      var x = props.x,
          y = props.y,
          y0 = props.y0,
          horizontal = props.horizontal;

      var alignment = props.alignment || "middle";
      var size = alignment === "middle" ? width / 2 : width;
      var sign = horizontal ? -1 : 1;
      return {
        x0: alignment === "start" ? x : x - sign * size,
        x1: alignment === "end" ? x : x + sign * size,
        y0: y0,
        y1: y
      };
    }
  }, {
    key: "getVerticalBarPath",
    value: function getVerticalBarPath(props, width, cornerRadius) {
      var _getPosition = this.getPosition(props, width),
          x0 = _getPosition.x0,
          x1 = _getPosition.x1,
          y0 = _getPosition.y0,
          y1 = _getPosition.y1;

      var sign = y0 > y1 ? 1 : -1;
      var direction = sign > 0 ? "0 0 1" : "0 0 0";
      var topArc = cornerRadius.top + " " + cornerRadius.top + " " + direction;
      var bottomArc = cornerRadius.bottom + " " + cornerRadius.bottom + " " + direction;
      return "M " + (x0 + cornerRadius.bottom) + ", " + y0 + "\n      A " + bottomArc + ", " + x0 + ", " + (y0 - sign * cornerRadius.bottom) + "\n      L " + x0 + ", " + (y1 + sign * cornerRadius.top) + "\n      A " + topArc + ", " + (x0 + cornerRadius.top) + ", " + y1 + "\n      L " + (x1 - cornerRadius.top) + ", " + y1 + "\n      A " + topArc + ", " + x1 + ", " + (y1 + sign * cornerRadius.top) + "\n      L " + x1 + ", " + (y0 - sign * cornerRadius.bottom) + "\n      A " + bottomArc + ", " + (x1 - cornerRadius.bottom) + ", " + y0 + "\n      z";
    }
  }, {
    key: "getHorizontalBarPath",
    value: function getHorizontalBarPath(props, width, cornerRadius) {
      var _getPosition2 = this.getPosition(props, width),
          x0 = _getPosition2.x0,
          x1 = _getPosition2.x1,
          y0 = _getPosition2.y0,
          y1 = _getPosition2.y1;

      var sign = y1 > y0 ? 1 : -1;
      var direction = sign > 0 ? "0 0 1" : "0 0 0";
      var topArc = cornerRadius.top + " " + cornerRadius.top + " " + direction;
      var bottomArc = cornerRadius.bottom + " " + cornerRadius.bottom + " " + direction;
      return "M " + y0 + ", " + (x1 + sign * cornerRadius.bottom) + "\n      A " + bottomArc + ", " + (y0 + cornerRadius.bottom) + ", " + x1 + "\n      L " + (y1 - sign * cornerRadius.top) + ", " + x1 + "\n      A " + topArc + ", " + y1 + ", " + (x1 + cornerRadius.top) + "\n      L " + y1 + ", " + (x0 - cornerRadius.top) + "\n      A " + topArc + ", " + (y1 - sign * cornerRadius.top) + ", " + x0 + "\n      L " + (y0 + cornerRadius.bottom) + ", " + x0 + "\n      A " + bottomArc + ", " + y0 + ", " + (x0 - sign * cornerRadius.bottom) + "\n      z";
    }
  }, {
    key: "transformAngle",
    value: function transformAngle(angle) {
      return -1 * angle + Math.PI / 2;
    }
  }, {
    key: "getAngularWidth",
    value: function getAngularWidth(props, width) {
      var scale = props.scale;

      var range = scale.y.range();
      var r = Math.max.apply(Math, _toConsumableArray(range));
      var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
      return width / (2 * Math.PI * r) * angularRange;
    }
  }, {
    key: "getAngle",
    value: function getAngle(props, index) {
      var data = props.data,
          scale = props.scale;

      var x = data[index]._x1 === undefined ? "_x" : "_x1";
      return scale.x(data[index][x]);
    }
  }, {
    key: "getStartAngle",
    value: function getStartAngle(props, index) {
      var data = props.data,
          scale = props.scale,
          alignment = props.alignment;

      var currentAngle = this.getAngle(props, index);
      var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
      var previousAngle = index === 0 ? this.getAngle(props, data.length - 1) - Math.PI * 2 : this.getAngle(props, index - 1);
      if (index === 0 && angularRange < 2 * Math.PI) {
        return scale.x.range()[0];
      } else if (alignment === "start" || alignment === "end") {
        return alignment === "start" ? previousAngle : currentAngle;
      } else {
        return (currentAngle + previousAngle) / 2;
      }
    }
  }, {
    key: "getEndAngle",
    value: function getEndAngle(props, index) {
      var data = props.data,
          scale = props.scale,
          alignment = props.alignment;

      var currentAngle = this.getAngle(props, index);
      var angularRange = Math.abs(scale.x.range()[1] - scale.x.range()[0]);
      var lastAngle = scale.x.range()[1] === 2 * Math.PI ? this.getAngle(props, 0) + Math.PI * 2 : scale.x.range()[1];
      var nextAngle = index === data.length - 1 ? this.getAngle(props, 0) + Math.PI * 2 : this.getAngle(props, index + 1);
      if (index === data.length - 1 && angularRange < 2 * Math.PI) {
        return lastAngle;
      } else if (alignment === "start" || alignment === "end") {
        return alignment === "start" ? currentAngle : nextAngle;
      } else {
        return (currentAngle + nextAngle) / 2;
      }
    }
  }, {
    key: "getVerticalPolarBarPath",
    value: function getVerticalPolarBarPath(props, cornerRadius) {
      var _this2 = this;

      // eslint-disable-line max-statements
      var datum = props.datum,
          scale = props.scale,
          index = props.index,
          alignment = props.alignment;

      var style = Helpers.evaluateStyle(props.style, datum, props.active);
      var r1 = scale.y(datum._y0 || 0);
      var r2 = scale.y(datum._y1 !== undefined ? datum._y1 : datum._y);
      var currentAngle = scale.x(datum._x1 !== undefined ? datum._x1 : datum._x);
      var start = void 0;
      var end = void 0;
      if (style.width) {
        var width = this.getAngularWidth(props, style.width);
        var size = alignment === "middle" ? width / 2 : width;
        start = alignment === "start" ? currentAngle : currentAngle - size;
        end = alignment === "end" ? currentAngle : currentAngle + size;
      } else {
        start = this.getStartAngle(props, index);
        end = this.getEndAngle(props, index);
      }

      var getPath = function (edge) {
        var pathFunction = d3Shape.arc().innerRadius(r1).outerRadius(r2).startAngle(_this2.transformAngle(start)).endAngle(_this2.transformAngle(end)).cornerRadius(cornerRadius[edge]);
        var path = pathFunction();
        var moves = path.match(/[A-Z]/g);
        var middle = moves.indexOf("L");
        var coords = path.split(/[A-Z]/).slice(1);
        var subMoves = edge === "top" ? moves.slice(0, middle) : moves.slice(middle);
        var subCoords = edge === "top" ? coords.slice(0, middle) : coords.slice(middle);
        return subMoves.map(function (m, i) {
          return { command: m, coords: subCoords[i].split(",") };
        });
      };

      var moves = getPath("top").concat(getPath("bottom"));
      return moves.reduce(function (memo, move) {
        memo += move.command + " " + move.coords.join();
        return memo;
      }, "");
    }
  }, {
    key: "getBarPath",
    value: function getBarPath(props, width, cornerRadius) {
      return this.props.horizontal ? this.getHorizontalBarPath(props, width, cornerRadius) : this.getVerticalBarPath(props, width, cornerRadius);
    }
  }, {
    key: "getPolarBarPath",
    value: function getPolarBarPath(props, cornerRadius) {
      // TODO Radial bars
      return this.getVerticalPolarBarPath(props, cornerRadius);
    }
  }, {
    key: "getBarWidth",
    value: function getBarWidth(props, style) {
      if (style.width) {
        return style.width;
      }
      var scale = props.scale,
          data = props.data;

      var range = scale.x.range();
      var extent = Math.abs(range[1] - range[0]);
      var bars = data.length + 2;
      var barRatio = props.barRatio || 0.5;
      // eslint-disable-next-line no-magic-numbers
      var defaultWidth = data.length < 2 ? 8 : barRatio * extent / bars;
      return Math.max(1, defaultWidth);
    }
  }, {
    key: "getCornerRadius",
    value: function getCornerRadius(props) {
      var cornerRadius = props.cornerRadius,
          datum = props.datum,
          active = props.active;

      if (!cornerRadius) {
        return { top: 0, bottom: 0 };
      } else if (_isObject(cornerRadius)) {
        return {
          top: Helpers.evaluateProp(cornerRadius.top, datum, active),
          bottom: Helpers.evaluateProp(cornerRadius.bottom, datum, active)
        };
      } else {
        return {
          top: Helpers.evaluateProp(cornerRadius, datum, active),
          bottom: 0
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          role = _props.role,
          datum = _props.datum,
          active = _props.active,
          shapeRendering = _props.shapeRendering,
          className = _props.className,
          origin = _props.origin,
          polar = _props.polar,
          pathComponent = _props.pathComponent,
          events = _props.events;

      var stroke = this.props.style && this.props.style.fill || "black";
      var baseStyle = { fill: "black", stroke: stroke };
      var style = Helpers.evaluateStyle(_assign(baseStyle, this.props.style), datum, active);
      var width = this.getBarWidth(this.props, style);
      var cornerRadius = this.getCornerRadius(this.props);
      var path = polar ? this.getPolarBarPath(this.props, cornerRadius) : this.getBarPath(this.props, width, cornerRadius);
      var transform = polar && origin ? "translate(" + origin.x + ", " + origin.y + ")" : undefined;
      return React.cloneElement(pathComponent, {
        d: path, transform: transform, className: className, style: style, role: role, shapeRendering: shapeRendering, events: events
      });
    }
  }]);

  return Bar;
}(React.Component);

Bar.propTypes = _extends({}, CommonProps, {
  alignment: PropTypes.oneOf(["start", "middle", "end"]),
  barRatio: PropTypes.number,
  cornerRadius: PropTypes.oneOfType([PropTypes.number, PropTypes.func, PropTypes.shape({
    top: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
    bottom: PropTypes.oneOfType([PropTypes.number, PropTypes.func])
  })]),
  datum: PropTypes.object,
  horizontal: PropTypes.bool,
  padding: PropTypes.oneOfType([PropTypes.number, PropTypes.object]),
  pathComponent: PropTypes.element,
  width: PropTypes.number,
  x: PropTypes.number,
  y: PropTypes.number,
  y0: PropTypes.number
});
Bar.defaultProps = {
  pathComponent: React.createElement(Path, null)
};
export default Bar;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/es/victory-primitives/bar.js
// module id = 1775
// module chunks = 0